module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('form-wizard', {
    attrs: {
      "shape": "tab",
      "color": "#9b59b6",
      "title": "Schulungs Import",
      "subtitle": "",
      "nextButtonText": "Weiter",
      "backButtonText": "Zurück",
      "finishButtonText": "Erstellen"
    },
    on: {
      "on-complete": _vm.onComplete
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Allgemeine Einstellungen",
      "icon": "fa fa-cogs"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "projectname"
    }
  }, [_vm._v("Schulungsname:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectname),
      expression: "projectname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "projectname"
    },
    domProps: {
      "value": (_vm.projectname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.projectname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Vorschaubild:")]), _vm._v(" "), _c('vue-dropzone', {
    ref: "previewImageDropzone",
    attrs: {
      "id": "previewImageDropzone",
      "options": _vm.previewDropzoneImage
    },
    on: {
      "vdropzone-queue-complete": _vm.preview_upload_complete,
      "vdropzone-sending": _vm.previewImageSending
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Schulungsinhalte:")]), _vm._v(" "), _c('itemlist', {
    ref: "contentsList"
  })], 1)]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Farben",
      "icon": "fa fa-cogs"
    }
  }, [_c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Folien Textfarbe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-swatches', {
    attrs: {
      "swatches": "text-advanced"
    },
    model: {
      value: (_vm.text_color),
      callback: function($$v) {
        _vm.text_color = $$v
      },
      expression: "text_color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Folien Hintergrundfarbe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-swatches', {
    attrs: {
      "swatches": "text-advanced"
    },
    model: {
      value: (_vm.background_color),
      callback: function($$v) {
        _vm.background_color = $$v
      },
      expression: "background_color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Rahmentitel Textfarbe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-swatches', {
    attrs: {
      "swatches": "text-advanced"
    },
    model: {
      value: (_vm.text_border_color),
      callback: function($$v) {
        _vm.text_border_color = $$v
      },
      expression: "text_border_color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Obere Rahmenfarbe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-swatches', {
    attrs: {
      "swatches": "text-advanced"
    },
    model: {
      value: (_vm.border_top_color),
      callback: function($$v) {
        _vm.border_top_color = $$v
      },
      expression: "border_top_color"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row col-md-12"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Untere Rahmenfarbe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('v-swatches', {
    attrs: {
      "swatches": "text-advanced"
    },
    model: {
      value: (_vm.border_bottom_color),
      callback: function($$v) {
        _vm.border_bottom_color = $$v
      },
      expression: "border_bottom_color"
    }
  })], 1)])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Fragen",
      "icon": "fa fa-cogs"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Frage Schriftgröße")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question_header_size),
      expression: "question_header_size"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "question_header_size"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.question_header_size = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "h1"
    }
  }, [_vm._v("Überschrift 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h2"
    }
  }, [_vm._v("Überschrift 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h3"
    }
  }, [_vm._v("Überschrift 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h4"
    }
  }, [_vm._v("Überschrift 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h5"
    }
  }, [_vm._v("Überschrift 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h6"
    }
  }, [_vm._v("Überschrift 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "question_size"
    }
  }, [_vm._v("Antworten Schriftgröße")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question_size),
      expression: "question_size"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "question_size"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.question_size = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "h1"
    }
  }, [_vm._v("Überschrift 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h2"
    }
  }, [_vm._v("Überschrift 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h3"
    }
  }, [_vm._v("Überschrift 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h4"
    }
  }, [_vm._v("Überschrift 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h5"
    }
  }, [_vm._v("Überschrift 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "h6"
    }
  }, [_vm._v("Überschrift 6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "show_question_answer"
    }
  }, [_vm._v("Anzahl richtiger Antworten anzeigen")]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show_question_answer),
      expression: "show_question_answer"
    }],
    attrs: {
      "type": "checkbox",
      "id": "show_question_answer",
      "name": "show_question_answer"
    },
    domProps: {
      "checked": Array.isArray(_vm.show_question_answer) ? _vm._i(_vm.show_question_answer, null) > -1 : (_vm.show_question_answer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.show_question_answer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.show_question_answer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.show_question_answer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.show_question_answer = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Folien Upload",
      "icon": "fa fa-upload"
    }
  }, [_c('vue-dropzone', {
    ref: "pageDropzone",
    attrs: {
      "id": "dropzone",
      "options": _vm.PagedropzoneOptions
    },
    on: {
      "vdropzone-sending": _vm.PageSending,
      "vdropzone-queue-complete": _vm.page_uploaded_complete
    }
  })], 1), _vm._v(" "), _c('tab-content', {
    attrs: {
      "title": "Weitere Einstellungen",
      "icon": "fa fa-question-circle"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Emailversand")]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.training_email),
      expression: "training_email"
    }],
    attrs: {
      "type": "checkbox",
      "name": "training_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.training_email) ? _vm._i(_vm.training_email, null) > -1 : (_vm.training_email)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.training_email,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.training_email = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.training_email = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.training_email = $$c
        }
      }
    }
  })])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Unternehmens Schulung")]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company_training),
      expression: "company_training"
    }],
    attrs: {
      "type": "checkbox",
      "name": "company_training"
    },
    domProps: {
      "checked": Array.isArray(_vm.company_training) ? _vm._i(_vm.company_training, null) > -1 : (_vm.company_training)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company_training,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.company_training = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.company_training = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.company_training = $$c
        }
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Zertifikatsgültigkeit (in Monaten):")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validate_till),
      expression: "validate_till"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "validate_till"
    },
    domProps: {
      "value": (_vm.validate_till)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.validate_till = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Rezertifizierungzeitraum (in Monaten):")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.validate_yellow),
      expression: "validate_yellow"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "validate_yellow"
    },
    domProps: {
      "value": (_vm.validate_yellow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.validate_yellow = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Schulung gesperrt bis zum Beginn des Rezertifizierungszeitraum")]), _vm._v(" "), _c('div', {
    staticClass: "form-check form-check-inline"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lock_till_yellow),
      expression: "lock_till_yellow"
    }],
    attrs: {
      "type": "checkbox",
      "name": "lock_till_yellow"
    },
    domProps: {
      "checked": Array.isArray(_vm.lock_till_yellow) ? _vm._i(_vm.lock_till_yellow, null) > -1 : (_vm.lock_till_yellow)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.lock_till_yellow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.lock_till_yellow = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.lock_till_yellow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.lock_till_yellow = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Token-Wertigkeit :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.training_value),
      expression: "training_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "readonly": _vm.change_token_value,
      "name": "training_value"
    },
    domProps: {
      "value": (_vm.training_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.training_value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("Anzahl Fragegruppen :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questiongroup_count),
      expression: "questiongroup_count"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "count_questions"
    },
    domProps: {
      "value": (_vm.questiongroup_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.questiongroup_count = $event.target.value
      }
    }
  })])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-499fdebf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ProjectImport.vue
// module id = 109
// module chunks = 0